<InactivityModal></InactivityModal>

<div class="d-flex flex-column bg-gray">
  <HomeNavBar
    @sidebar-toggle="toggleSidebar"
    class="navbar navbar-expand-lg sticky-top bg-white border-bottom w-100 p-0 m-0"
  ></HomeNavBar>

  <div class="container-fluid flex-grow-1">
    <div class="row">
      <div class="col-12 overflow-auto mt-2 mb-5 pb-3">
          <div class="container-fluid px-2 px-sm-3 px-lg-4 pb-4">
          <section class="event-survey-experience card border-0 shadow-sm rounded mb-3 overflow-hidden">
            <div class="card-body p-3">
              <div class="row g-4 align-items-center">
                <div class="col-12">
                  <div class="d-inline-flex align-items-center gap-2 px-3 py-2 rounded-pill bg-white border text-dark text-xxs fw-bold mb-2">
                    <i class="bi bi-heart-fill text-danger"></i>
                    Donation Campaigns
                  </div>
                  <h5 class="fw-bold text-dark mb-2">
                    {{ active_tab === 'detail' && selected_campaign ? '' : 'Let anyone create, share, and manage campaigns.' }}
                  </h5>
                  <p class="text-muted mb-2 d-none d-md-block">
                    {{
                      active_tab === 'detail' && selected_campaign
                        ? 'Review the campaign story, timeline, goal, and current progress.'
                        : 'Explore campaigns, create your own, and manage them in one place.'
                    }}
                  </p>

                  <div class="d-flex flex-wrap gap-2 mb-4">
                    <button
                      v-if="active_tab === 'detail' && selected_campaign"
                      type="button"
                      class="btn btn-light border rounded px-3"
                      @click="go_to_explore_page()"
                    >
                      <i class="bi bi-arrow-left me-2"></i><span class="d-inline d-sm-none">Back</span><span class="d-none d-sm-inline">Back to Campaigns</span>
                    </button>
                    <button
                      v-else
                      type="button"
                      class="btn btn-primary rounded px-3"
                      @click="go_to_explore_page()"
                    >
                      <i class="bi bi-compass me-2"></i><span class="d-inline d-sm-none">Explore</span><span class="d-none d-sm-inline">Explore Campaigns</span>
                    </button>
                    <button
                      type="button"
                      class="btn btn-light border rounded px-3"
                      @click="go_to_manage_page()"
                    >
                      <i class="bi bi-kanban me-2"></i>My Campaigns
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <div
            v-if="show_explore_loader"
            class="marketplace-loader-wrap d-flex align-items-center justify-content-center"
            role="status"
            aria-live="polite"
          >
            <div class="marketplace-loader-card">
              <div class="marketplace-loader-orbit">
                <span class="marketplace-loader-ring marketplace-loader-ring-primary"></span>
                <span class="marketplace-loader-ring marketplace-loader-ring-secondary"></span>
                <span class="marketplace-loader-core d-flex align-items-center justify-content-center">
                  <i class="bi bi-heart fs-2 text-danger"></i>
                </span>
                <span class="marketplace-loader-dot marketplace-loader-dot-one"></span>
                <span class="marketplace-loader-dot marketplace-loader-dot-two"></span>
              </div>
              <p class="marketplace-loader-title mb-1">Loading campaigns</p>
              <p class="marketplace-loader-copy mb-0">We are bringing campaign stories and progress into view.</p>
            </div>
          </div>

          <div
            v-else-if="show_detail_loader"
            class="marketplace-loader-wrap d-flex align-items-center justify-content-center"
            role="status"
            aria-live="polite"
          >
            <div class="marketplace-loader-card">
              <div class="marketplace-loader-orbit">
                <span class="marketplace-loader-ring marketplace-loader-ring-primary"></span>
                <span class="marketplace-loader-ring marketplace-loader-ring-secondary"></span>
                <span class="marketplace-loader-core d-flex align-items-center justify-content-center">
                  <i class="bi bi-heart fs-2 text-danger"></i>
                </span>
                <span class="marketplace-loader-dot marketplace-loader-dot-one"></span>
                <span class="marketplace-loader-dot marketplace-loader-dot-two"></span>
              </div>
              <p class="marketplace-loader-title mb-1">Loading campaign</p>
              <p class="marketplace-loader-copy mb-0">We are preparing the campaign details for you.</p>
            </div>
          </div>

          <div v-else-if="active_tab === 'explore'" class="row g-3">
            <div class="col-12">
              <div v-if="filtered_campaigns.length" class="row g-3">
                <div class="col-12 col-sm-6 col-lg-4 col-xl-3" v-for="campaign in filtered_campaigns" :key="campaign.id">
                  <div class="marketplace-product-card cursor-pointer h-100 d-flex flex-column" role="button" tabindex="0" @click="open_campaign_detail(campaign)">
                    <div class="position-relative marketplace-card-media">
                      <div class="event-view-sidebar-cover rounded overflow-hidden bg-light">
                        <img
                          v-if="get_campaign_cover_image(campaign)"
                          :src="get_campaign_cover_image(campaign)"
                          :alt="campaign?.name || 'Untitled campaign'"
                          class="event-view-sidebar-cover-image"
                        />
                        <div v-else class="w-100 h-100 bg-light d-flex flex-column align-items-center justify-content-center text-muted text-center p-3">
                          <i class="bi bi-image fs-4 mb-2"></i>
                          <span class="text-xxs fw-500">No campaign image</span>
                        </div>
                      </div>
                      <div class="position-absolute top-0 start-0 mt-4 ms-2 d-flex gap-2 flex-wrap">
                        <span class="marketplace-card-pill my-events-pill my-events-pill--published">
                          {{ campaign?.category?.name || campaign?.category || "Uncategorized" }}
                        </span>
                      </div>
                      <span v-if="campaign.end_date" class="position-absolute top-0 end-0 mt-4 me-2 task-chip task-chip-priority">
                        {{ calculate_days_left(campaign.end_date) }} days left
                      </span>
                    </div>

                    <div class="card-body p-3 d-flex flex-column text-start marketplace-card-body flex-grow-1">
                      <div class="flex-grow-1">
                        <div class="d-flex justify-content-between align-items-start gap-2 mb-1">
                          <p class="marketplace-card-name mb-0">{{ campaign?.name || "Untitled campaign" }}</p>
                          <span class="task-chip task-chip-status text-capitalize flex-shrink-0">
                            {{ campaign.status }}
                          </span>
                        </div>
                        <div class="text-xs text-muted mb-1">{{ get_campaign_summary(campaign.description || "") }}</div>
                        <div class="text-xs text-muted mb-0">
                          {{ format_date(campaign.start_date) }} - {{ format_date(campaign.end_date) }}
                        </div>
                      </div>

                      <div class="mt-3">
                        <div class="d-flex justify-content-between align-items-center gap-2 mb-1">
                          <div class="fw-bold text-dark text-xs">{{ format_currency(get_campaign_raised_amount(campaign)) }}</div>
                          <div class="text-muted text-xxs">Goal {{ format_currency(campaign.goal_amount) }}</div>
                        </div>
                        <div class="progress mb-3">
                          <div
                            class="progress-bar bg-danger"
                            role="progressbar"
                            :style="{ width: `${get_progress_width(campaign)}%` }"
                            :aria-valuenow="get_progress_width(campaign)"
                            aria-valuemin="0"
                            aria-valuemax="100"
                          ></div>
                        </div>
                      </div>

                      <div class="d-flex justify-content-between align-items-end gap-2 mt-auto marketplace-card-footer" @click.stop>
                        <button
                          type="button"
                          class="btn btn-sm btn-primary text-xxs rounded px-3 py-1"
                          @click.stop.prevent="open_donation_modal(campaign)"
                        >
                          <i class="bi bi-heart-fill me-2"></i>Donate
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div v-else class="text-center py-5">
                <i class="bi bi-heart text-muted display-6"></i>
                <h6 class="fw-bold text-dark mt-3 mb-1">No active campaigns found</h6>
                <p class="text-muted small mb-0">There are no live campaigns to explore right now.</p>
              </div>
            </div>
          </div>

          <div v-else-if="active_tab === 'detail' && selected_campaign" class="row g-3 mb-4">
            <div class="col-12">
              <section class="overflow-hidden">
                <div class="p-0">
                  <div class="row g-4 align-items-stretch">
                    <div class="col-12 col-xl-9">
                      <div class="card board-task-card border-0 rounded-4 bg-white shadow-sm overflow-hidden h-100">
                        <div class="card-body p-3 h-100">
                          <div class="row g-3 h-100">
                            <div class="col-12 col-lg-5">
                              <div class="position-relative h-100 rounded overflow-hidden">
                                <div v-if="get_campaign_cover_image(selected_campaign)" class="event-view-sidebar-cover rounded overflow-hidden bg-light">
                                  <img
                                    :src="get_campaign_cover_image(selected_campaign)"
                                    :alt="selected_campaign?.name || 'Untitled campaign'"
                                    class="event-view-sidebar-cover-image"
                                  />
                                </div>
                                <div v-else class="event-view-sidebar-cover rounded overflow-hidden bg-light d-flex flex-column align-items-center justify-content-center text-muted text-center p-4">
                                  <i class="bi bi-image fs-2 mb-2"></i>
                                  <span class="text-xxs fw-500">No campaign image</span>
                                </div>

                              </div>
                            </div>

                            <div class="col-12 col-lg-7">
                              <div class="h-100 d-flex flex-column">
                                <div class="d-flex align-items-start justify-content-between gap-2 mb-3">
                                  <h2 class="fw-bold text-dark mb-0">{{ selected_campaign.name || "Untitled campaign" }}</h2>
                                  <span class="task-chip task-chip-status text-capitalize flex-shrink-0">{{ selected_campaign.status }}</span>
                                </div>

                                <div class="text-xxs mb-3 fw-semibold">
                                  <span class="text-dark">By </span><span class="text-primary">{{
                                    `${selected_campaign?.created_by_profile?.user?.first_name || ""} ${selected_campaign?.created_by_profile?.user?.last_name || ""}`.trim()
                                    || selected_campaign?.created_by_profile?.profile_name
                                    || "Campaign creator"
                                  }}</span>
                                </div>

                                <div class="mb-3">
                                  <p class="text-muted mb-0 d-block d-md-none">
                                    {{
                                      mobile_description_expanded
                                        ? (selected_campaign.description || "No campaign description yet.")
                                        : get_campaign_summary(selected_campaign.description || "")
                                    }}
                                  </p>
                                  <button
                                    v-if="is_long_campaign_description(selected_campaign.description)"
                                    type="button"
                                    class="btn btn-link d-md-none text-xxs px-0 pt-1 pb-0 text-decoration-none shadow-none"
                                    @click="toggle_mobile_description"
                                  >
                                    {{ mobile_description_expanded ? 'Read less' : 'Read more' }}
                                  </button>
                                  <p class="text-muted mb-0 d-none d-md-block">
                                    {{ selected_campaign.description || "No campaign description yet." }}
                                  </p>
                                </div>

                                <div class="row g-2 mt-auto">
                                  <div class="col-12 col-md-4">
                                    <div class="border rounded bg-light h-100 p-2">
                                      <div class="d-flex align-items-start gap-2">
                                        <i class="bi bi-calendar-event text-secondary mt-1"></i>
                                        <div>
                                          <div class="text-dark text-xxs fw-bold text-uppercase mb-1">Start Date</div>
                                          <div class="text-muted text-xxs">{{ format_date(selected_campaign.start_date) }}</div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="col-12 col-md-4">
                                    <div class="border rounded bg-light h-100 p-2">
                                      <div class="d-flex align-items-start gap-2">
                                        <i class="bi bi-calendar-check text-secondary mt-1"></i>
                                        <div>
                                          <div class="text-dark text-xxs fw-bold text-uppercase mb-1">End Date</div>
                                          <div class="text-muted text-xxs">{{ format_date(selected_campaign.end_date) }}</div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="col-12 col-md-4">
                                    <div class="border rounded bg-light h-100 p-2">
                                      <div class="d-flex align-items-start gap-2">
                                        <i class="bi bi-grid text-secondary mt-1"></i>
                                        <div>
                                          <div class="text-dark text-xxs fw-bold text-uppercase mb-1">Category</div>
                                          <div class="text-muted text-xxs">{{ selected_campaign?.category?.name || selected_campaign?.category || "Uncategorized" }}</div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="col-12 col-xl-3">
                      <div class="card board-task-card border-0 rounded-4 bg-white shadow-sm h-100">
                        <div class="card-body p-4 h-100 d-flex flex-column">
                          <div class="fw-bold text-dark fs-3 mb-1">{{ format_currency(get_campaign_raised_amount(selected_campaign)) }}</div>
                          <div class="text-muted mb-3">Raised of {{ format_currency(selected_campaign.goal_amount) }} goal</div>

                          <div class="d-flex align-items-center gap-3 mb-3">
                            <div class="progress flex-grow-1">
                              <div
                                class="progress-bar bg-primary"
                                role="progressbar"
                                :style="{ width: `${get_progress_width(selected_campaign)}%` }"
                                :aria-valuenow="get_progress_width(selected_campaign)"
                                aria-valuemin="0"
                                aria-valuemax="100"
                              ></div>
                            </div>
                            <span class="fw-bold text-dark text-xxs">{{ get_progress(selected_campaign) }}%</span>
                          </div>

                          <div class="row g-2 mb-3">
                            <div class="col-6">
                              <div class="border rounded bg-light h-100 p-3">
                                <div class="fw-bold text-dark d-flex align-items-center gap-2">
                                  <i class="bi bi-people"></i>
                                  {{ selected_campaign_donor_count }}
                                </div>
                                <div class="text-muted">Donors</div>
                              </div>
                            </div>
                            <div class="col-6">
                              <div class="border rounded bg-light h-100 p-3">
                                <div class="fw-bold text-dark d-flex align-items-center gap-2">
                                  <i class="bi bi-clock-history"></i>
                                  {{ selected_campaign.end_date ? calculate_days_left(selected_campaign.end_date) : 0 }}
                                </div>
                                <div class="text-muted">Days left</div>
                              </div>
                            </div>
                          </div>

                          <div class="d-flex flex-column flex-sm-row gap-2 mt-auto">
                            <button
                              type="button"
                              class="btn btn-primary flex-fill fw-semibold rounded shadow-sm px-3 py-2"
                              @click="open_donation_modal(selected_campaign)"
                            >
                              <i class="bi bi-heart-fill me-2"></i>Donate Now
                            </button>
                            <button
                              type="button"
                              class="btn btn-light border flex-fill fw-semibold rounded shadow-sm px-3 py-2 d-none"
                              disabled
                            >
                              <i class="bi bi-share me-2"></i>Share Campaign
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="row mt-3">
                    <div class="col-12 col-xl-9">
                      <div class="d-flex align-items-center justify-content-center justify-content-xl-between flex-wrap gap-2 mb-2 py-2 py-xl-0">
                        <div class="marketplace-tabs-shell d-inline-flex align-items-center flex-nowrap overflow-auto">
                          <button
                            type="button"
                            class="marketplace-tab-btn fw-semibold d-inline-flex align-items-center gap-2 px-4 py-3"
                            :class="detail_tab === 'donors' ? 'is-active bg-primary text-white' : 'text-muted'"
                            @click="set_detail_tab('donors')"
                          >
                            <span>Donors</span>
                            <span class="badge rounded" :class="detail_tab === 'donors' ? 'bg-white text-primary' : 'bg-white text-muted border'">{{ selected_campaign_donor_count }}</span>
                          </button>
                          <button
                            type="button"
                            class="marketplace-tab-btn fw-semibold d-inline-flex align-items-center gap-2 px-4 py-3"
                            :class="detail_tab === 'comments' ? 'is-active bg-primary text-white' : 'text-muted'"
                            @click="set_detail_tab('comments')"
                          >
                            <span>Comments</span>
                            <span class="badge rounded" :class="detail_tab === 'comments' ? 'bg-white text-primary' : 'bg-white text-muted border'">{{ selected_campaign_comments.length }}</span>
                          </button>
                          <button
                            type="button"
                            class="marketplace-tab-btn fw-semibold d-inline-flex align-items-center gap-2 px-4 py-3"
                            :class="detail_tab === 'documents' ? 'is-active bg-primary text-white' : 'text-muted'"
                            @click="set_detail_tab('documents')"
                          >
                            <span>Documents</span>
                            <span class="badge rounded" :class="detail_tab === 'documents' ? 'bg-white text-primary' : 'bg-white text-muted border'">{{ selected_campaign_supporting_files.length }}</span>
                          </button>
                        </div>
                      </div>

                      <div class="card board-task-card border-0 rounded-4 bg-white shadow-sm overflow-hidden">
                        <div class="card-body p-3 p-lg-4">
                        <div v-if="detail_tab === 'donors'">
                          <div class="d-flex align-items-center justify-content-between gap-2 mb-3">
                            <h5 class="fw-bold text-dark mb-0">Campaign donors</h5>
                            <div class="d-flex align-items-center gap-2">
                              <span class="text-muted text-xxs fw-500">Sort</span>
                              <select
                                :value="donor_sort"
                                class="form-select form-select-sm rounded shadow-none text-xxs w-auto"
                                @change="set_donor_sort($event.target.value)"
                              >
                                <option value="highest">Highest</option>
                                <option value="lowest">Lowest</option>
                              </select>
                            </div>
                          </div>

                          <div v-if="selected_campaign_donations.length" class="border rounded-4 overflow-hidden bg-white">
                            <div class="d-none d-md-block border-bottom bg-light px-3 py-3">
                              <div class="row g-3">
                                <div class="col-md-3 text-dark text-xxs fw-bold text-uppercase">Donor</div>
                                <div class="col-md-4 text-dark text-xxs fw-bold text-uppercase">Message</div>
                                <div class="col-md-3 text-dark text-xxs fw-bold text-uppercase">Date</div>
                                <div class="col-md-2 text-dark text-xxs fw-bold text-uppercase text-end">Amount</div>
                              </div>
                            </div>

                            <div
                              v-for="donation in paginated_campaign_donations"
                              :key="donation.id"
                              class="px-3 py-3 border-bottom"
                            >
                              <div class="d-flex d-md-none align-items-start justify-content-between gap-3 mb-2">
                                <div>
                                  <div class="fw-semibold text-dark text-xxs">
                                    {{ donation.is_anonymous ? "Anonymous" : (donation.donor_name || "Donor") }}
                                  </div>
                                  <div class="text-muted text-xxs mt-1">
                                    {{ format_datetime(donation.date_donated || donation.created_at) }}
                                  </div>
                                </div>
                                <div class="fw-bold text-dark text-xxs text-nowrap">
                                  {{ format_currency(donation.amount) }}
                                </div>
                              </div>

                              <div class="d-md-none text-muted text-xxs">
                                {{ donation.message || "No message" }}
                              </div>

                              <div class="d-none d-md-block">
                                <div class="row g-3 align-items-center">
                                <div class="col-md-3">
                                  <div class="fw-semibold text-dark text-xxs">
                                    {{ donation.is_anonymous ? "Anonymous" : (donation.donor_name || "Donor") }}
                                  </div>
                                </div>
                                <div class="col-md-4">
                                  <div class="text-muted text-xxs">
                                    {{ donation.message || "No message" }}
                                  </div>
                                </div>
                                <div class="col-md-3">
                                  <div class="text-muted text-xxs">
                                    {{ format_datetime(donation.date_donated || donation.created_at) }}
                                  </div>
                                </div>
                                <div class="col-md-2 text-end">
                                  <div class="fw-bold text-dark text-xxs text-nowrap">
                                    {{ format_currency(donation.amount) }}
                                  </div>
                                </div>
                                </div>
                              </div>
                            </div>

                            <div v-if="donor_total_pages > 1" class="d-flex align-items-center justify-content-between gap-2 px-3 py-3 bg-light">
                              <div class="text-muted text-xxs">
                                Page {{ donor_page }} of {{ donor_total_pages }}
                              </div>
                              <div class="d-flex align-items-center gap-2">
                                <button
                                  type="button"
                                  class="btn btn-sm btn-light border rounded text-xxs"
                                  :disabled="donor_page === 1"
                                  @click="set_donor_page(donor_page - 1)"
                                >
                                  Previous
                                </button>
                                <button
                                  type="button"
                                  class="btn btn-sm btn-light border rounded text-xxs"
                                  :disabled="donor_page === donor_total_pages"
                                  @click="set_donor_page(donor_page + 1)"
                                >
                                  Next
                                </button>
                              </div>
                            </div>
                          </div>

                          <div v-else class="border rounded-4 bg-light py-4 py-lg-5 px-3 text-center">
                            <i class="bi bi-people text-muted fs-2 mb-2"></i>
                            <div class="fw-bold text-dark mb-1">No donor activity yet</div>
                            <div class="text-muted text-xxs">Donor activity will appear here when donations are available.</div>
                          </div>
                        </div>

                        <div v-else-if="detail_tab === 'comments'">
                          <div class="d-flex align-items-center gap-2 pb-2 mb-3 text-primary border-bottom">
                            <i class="bi bi-chat-dots-fill"></i>
                            <span class="text-xxs fw-bold text-uppercase">Comments</span>
                          </div>

                          <div class="mb-3">
                            <div class="input-group border bg-white rounded-5 shadow-sm overflow-hidden">
                              <input
                              id="campaign_comment_field"
                              v-model="comment_form.comment"
                              type="text"
                              class="form-control comment-input border-0 bg-transparent text-xxs py-2 px-3"
                              :placeholder="editing_comment_id ? 'Edit your comment...' : 'Write a comment...'"
                              @keyup.enter.prevent="save_campaign_comment"
                            />
                              <button
                                v-if="editing_comment_id"
                                type="button"
                                class="btn btn-light px-2 py-1 border-0 text-xxs"
                                @click="cancel_comment_edit"
                              >
                                Cancel
                              </button>
                              <button
                                type="button"
                                class="btn btn-primary px-2 py-1 border-0"
                                :disabled="is_submitting_comment"
                                @click="save_campaign_comment"
                              >
                                <span
                                  v-if="is_submitting_comment"
                                  class="spinner-border spinner-border-sm"
                                  role="status"
                                  aria-hidden="true"
                                ></span>
                                <i v-else class="bi" :class="editing_comment_id ? 'bi-check2' : 'bi-send'"></i>
                              </button>
                            </div>
                            <p v-if="comment_errors.comment" class="text-danger text-xxs mt-1 mb-2">
                              {{ comment_errors.comment }}
                            </p>
                          </div>

                          <div v-if="selected_campaign_comments.length" class="d-flex flex-column gap-3">
                            <div
                              v-for="comment in selected_campaign_comments"
                              :key="comment.id"
                              class="d-flex align-items-start gap-3 p-3 rounded-3 bg-light border"
                            >
                              <img
                                :src="get_comment_profile_picture(comment) || require('@/assets/images/user.png')"
                                alt="Commenter Avatar"
                                loading="lazy"
                                class="profile-image rounded-5 profile-list-avatar flex-shrink-0"
                              />
                              <div class="w-100 min-w-0">
                                  <div class="d-flex justify-content-between align-items-start gap-2">
                                  <strong class="text-xs text-dark fw-bold text-break min-w-0">
                                    <span v-if="comment?.base_profile?.profile_type?.toLowerCase().trim() === 'personal'">
                                      {{ comment?.base_profile?.user?.first_name }} {{ comment?.base_profile?.user?.last_name }}
                                    </span>
                                    <span v-else>
                                      {{ comment?.base_profile?.company?.company_name || 'Commenter' }}
                                    </span>
                                  </strong>
                                    <div class="d-flex align-items-center gap-2 flex-shrink-0">
                                      <small class="text-muted text-xxs text-nowrap">
                                        {{ format_comment_time_ago(comment.created_at) }}
                                    </small>
                                    <div v-if="can_manage_comment(comment)" class="dropdown">
                                      <button
                                        class="btn btn-sm p-0 border-0 bg-transparent shadow-none"
                                        type="button"
                                        data-bs-toggle="dropdown"
                                        aria-expanded="false"
                                      >
                                        <i class="bi bi-three-dots-vertical text-muted"></i>
                                      </button>
                                      <ul class="dropdown-menu dropdown-menu-end text-xxs">
                                        <li>
                                          <button
                                            type="button"
                                            class="dropdown-item text-xxs"
                                            @click="start_comment_edit(comment)"
                                          >
                                            Edit
                                          </button>
                                        </li>
                                        <li>
                                          <button
                                            type="button"
                                            class="dropdown-item text-danger text-xxs"
                                            @click="delete_campaign_comment(comment)"
                                          >
                                            Delete
                                          </button>
                                        </li>
                                      </ul>
                                    </div>
                                  </div>
                                </div>

                                <div class="border-top my-3"></div>

                                <p class="mb-0 mt-3 text-xs text-dark text-break overflow-wrap-anywhere lh-base d-md-none">
                                  {{
                                    should_truncate_comment(comment?.comment || comment?.message || "") && !is_comment_expanded(comment.id)
                                        ? get_truncated_comment(comment?.comment || comment?.message || "")
                                        : (comment?.comment || comment?.message || "")
                                    }}
                                  </p>
                                  <p class="mb-0 mt-3 text-xs text-dark text-break overflow-wrap-anywhere lh-base d-none d-md-block">
                                    {{ comment?.comment || comment?.message || "" }}
                                  </p>
                                  <button
                                    v-if="should_truncate_comment(comment?.comment || comment?.message || '')"
                                    type="button"
                                    class="btn btn-link text-xxs text-decoration-none p-0 mt-2 d-md-none"
                                    @click="toggle_comment_expanded(comment.id)"
                                  >
                                    {{ is_comment_expanded(comment.id) ? 'See less' : 'See more' }}
                                  </button>
                                </div>
                              </div>
                            </div>

                          <div v-else class="border rounded-4 bg-light py-4 py-lg-5 px-3 text-center">
                            <i class="bi bi-chat-left-text text-muted fs-2 mb-2"></i>
                            <div class="fw-bold text-dark mb-1">No comments yet</div>
                            <div class="text-muted text-xxs">Comments will appear here once people start the conversation.</div>
                          </div>
                        </div>

                        <div v-else>
                          <div class="d-flex align-items-center justify-content-between gap-2 mb-3">
                            <h5 class="fw-bold text-dark mb-0">Campaign documents</h5>
                            <span class="text-muted text-xxs">{{ selected_campaign_supporting_files.length }} files</span>
                          </div>

                          <div v-if="selected_campaign_supporting_files.length" class="row g-3">
                            <div
                              v-for="(file, index) in selected_campaign_supporting_files"
                              :key="file.id || get_campaign_file_url(file) || index"
                              class="col-6 col-lg-3"
                            >
                              <button
                                type="button"
                                class="card board-task-card border rounded-5 bg-light shadow-sm text-decoration-none h-100 w-100 text-start"
                                @click="open_file_preview(file)"
                              >
                                <div class="ratio ratio-16x9 border-bottom rounded-top overflow-hidden bg-white">
                                  <img
                                    v-if="is_campaign_image_file(file)"
                                    :src="get_campaign_file_url(file)"
                                    :alt="get_campaign_file_name(file, index)"
                                    class="event-view-sidebar-cover-image"
                                  />
                                  <video
                                    v-else-if="is_campaign_video_file(file)"
                                    :src="get_campaign_file_url(file)"
                                    class="event-view-sidebar-cover-image"
                                    muted
                                  ></video>
                                  <div v-else class="d-flex align-items-center justify-content-center h-100">
                                    <i :class="['bi', get_campaign_file_icon_class(file), 'display-4']"></i>
                                  </div>
                                </div>
                                <div class="card-body p-3">
                                  <div class="fw-semibold text-dark text-xs mb-1" :title="get_campaign_file_name(file, index)">
                                    {{
                                      get_campaign_file_name(file, index).length > 24
                                        ? `${get_campaign_file_name(file, index).slice(0, 21)}...`
                                        : get_campaign_file_name(file, index)
                                    }}
                                  </div>
                                  <div class="text-muted text-xxs d-flex align-items-center justify-content-between">
                                    <span>{{ format_datetime(get_campaign_file_created_at(file)) || 'Open preview' }}</span>
                                    <i class="bi bi-box-arrow-up-right"></i>
                                  </div>
                                </div>
                              </button>
                            </div>
                          </div>

                          <div v-else class="border rounded-4 bg-light py-4 py-lg-5 px-3 text-center">
                            <i class="bi bi-file-earmark-text text-muted fs-2 mb-2"></i>
                            <div class="fw-bold text-dark mb-1">No supporting files yet</div>
                            <div class="text-muted text-xxs">Supporting documents, pictures, and videos will appear here once uploaded.</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

                </div>
              </section>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</div>

<teleport to="body">
  <div class="modal fade" id="campaign_file_preview_modal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg">
      <div class="modal-content border-0 rounded-4 shadow-sm overflow-hidden">
        <div class="modal-header border-0 shadow-sm">
          <h5 class="modal-title text-xs mb-0 text-truncate">{{ preview_file?.name || 'File preview' }}</h5>
          <button type="button" class="btn-close btn-close-black text-xs" data-bs-dismiss="modal" aria-label="Close" @click="clear_file_preview"></button>
        </div>
        <div class="modal-body p-3 p-lg-4">
          <div v-if="preview_file?.is_image" class="text-center">
            <img :src="preview_file.url" :alt="preview_file.name" class="img-fluid rounded" />
          </div>
          <div v-else-if="preview_file?.is_video">
            <video :src="preview_file.url" controls class="w-100 rounded"></video>
          </div>
          <div v-else-if="preview_file?.is_pdf" class="ratio ratio-16x9">
            <iframe :src="preview_file.url" title="PDF preview" class="rounded border"></iframe>
          </div>
          <div v-else class="text-center py-4">
            <i class="bi bi-file-earmark-text text-primary display-4"></i>
            <div class="fw-semibold text-dark mt-3 mb-1">{{ preview_file?.name }}</div>
            <div class="text-muted text-xxs mb-3">Preview is not available for this file type.</div>
            <a v-if="preview_file?.url" :href="preview_file.url" target="_blank" rel="noopener noreferrer" class="btn btn-primary btn-sm rounded px-3">
              Open File
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="modal fade" id="donation_checkout_modal" tabindex="-1" aria-labelledby="donationCheckoutLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content border-0 rounded-4 shadow-sm">
        <div class="modal-header border-0 shadow-sm">
          <div>
            <h5 class="modal-title text-xs mb-0" id="donationCheckoutLabel">Donate to Campaign</h5>
          </div>
          <button type="button" class="btn-close btn-close-black text-xs" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>

        <div class="modal-body pt-3">
          <div class="border rounded-4 bg-light p-3 mb-3">
            <div class="d-flex justify-content-between align-items-start gap-2">
              <div>
                <div class="fw-bold text-dark">{{ selected_donation_campaign?.name || "Campaign" }}</div>
                <div class="text-muted text-xxs">Goal {{ format_currency(selected_donation_campaign?.goal_amount) }}</div>
              </div>
              <div class="text-end">
                <div class="fw-bold text-dark">{{ format_currency(get_campaign_raised_amount(selected_donation_campaign)) }}</div>
                <div class="text-muted text-xxs">Raised so far</div>
              </div>
            </div>
          </div>

          <div class="mb-3">
            <label class="form-label text-xxs fw-500 text-dark">Choose an amount</label>
            <div class="d-flex flex-wrap gap-2">
              <button
                v-for="amount in donation_amount_presets"
                :key="amount"
                type="button"
                class="btn btn-sm rounded-pill px-3 py-2 text-xxs fw-semibold"
                :class="Number(donation_form.amount) === Number(amount) ? 'btn-primary' : 'btn-light border text-dark'"
                @click="select_donation_amount(amount)"
              >
                {{ format_currency(amount) }}
              </button>
            </div>
          </div>

          <div class="mb-3">
            <label for="campaign_donation_amount" class="form-label text-xxs fw-500 text-dark">Amount</label>
          <div class="input-group input-group-sm rounded-5">
            <span class="input-group-text bg-white border-end-0 rounded-start text-xxs">R</span>
            <input
              id="campaign_donation_amount"
              v-model="donation_form.amount"
                type="number"
                min="1"
                step="0.01"
                class="form-control border-start-0 rounded-end shadow-none text-xxs"
              placeholder="Enter amount"
            />
          </div>
          <p v-if="donation_errors.amount" class="text-danger text-xxs mt-1 mb-0">{{ donation_errors.amount }}</p>
        </div>

          <div class="mb-0">
            <label for="campaign_donation_message" class="form-label text-xxs fw-500 text-dark">Message <span class="text-muted fw-normal">(optional)</span></label>
            <textarea
              id="campaign_donation_message"
              v-model="donation_form.message"
              class="form-control rounded text-xxs shadow-none"
              rows="3"
              placeholder="Leave a short note"
            ></textarea>
          </div>

          <div class="form-check mt-3">
            <input
              id="campaign_donation_anonymous"
              v-model="donation_form.is_anonymous"
              class="form-check-input shadow-none"
              type="checkbox"
            />
            <label class="form-check-label text-xxs text-dark" for="campaign_donation_anonymous">
              Donate anonymously
            </label>
          </div>
        </div>

        <div class="modal-footer border-0 pt-0">
          <button type="button" class="btn btn-light border rounded-3 px-3" data-bs-dismiss="modal">Cancel</button>
          <button
            type="button"
            class="btn btn-primary rounded-3 px-4"
            :disabled="is_processing_donation"
            @click="start_donation_checkout"
          >
            <span v-if="is_processing_donation">Processing...</span>
            <span v-else><i class="bi bi-heart-fill me-2"></i>Proceed to Payment</span>
          </button>
        </div>
      </div>
    </div>
  </div>

  <form id="payment_form" :action="payfast" method="POST" class="d-none">
    <input type="submit" value="Submit" />
  </form>
  <input type="hidden" id="input_clone" class="d-none" />
</teleport>
